module.exports = __webpack_public_path__ + "static/media/boat-img-33.26015506.jpg";